import { Box, Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { type ReactFlowProps } from '@xyflow/react';

import { Alert, api, getQueryProps, isDefined, isTruthy } from 'common';

import { ReactFlowOverviewGraph } from '../../Flows/ReactFlow/Graph/View';

interface FlowTemplateDefinitionPreviewProps {
  templateId: string;
  height: number;
  borderRadiusInPixels?: number;
  onPaneClick?: ReactFlowProps['onPaneClick'];
}

export function FlowTemplateDefinitionPreview(props: FlowTemplateDefinitionPreviewProps) {
  const { templateId, height, borderRadiusInPixels, onPaneClick } = props;

  const {
    data: flowTemplate,
    isPending,
    error,
    isError,
  } = useQuery({
    ...getQueryProps(api.client.FlowDefinitionTemplate, 'findOneById', templateId),
    enabled: isTruthy(templateId),
  });

  if (isPending) {
    return <Skeleton width="100%" height={height} variant="rectangular" />;
  }
  if (isError) {
    return <Alert error={error} title="Error loading flow definition" />;
  }

  return (
    <Box width="100%" height={height}>
      {isDefined(flowTemplate?.data) &&
        isDefined(flowTemplate?.state) &&
        isDefined(flowTemplate?.version) && (
          <ReactFlowOverviewGraph
            flowDefinitionData={flowTemplate.data}
            maxZoom={1}
            flowDefinitionOverlayProps={{
              version: flowTemplate.version,
              state: flowTemplate.state,
            }}
            onPaneClick={onPaneClick}
            borderRadiusInPixels={borderRadiusInPixels}
          />
        )}
    </Box>
  );
}
